import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const GET_CAT_API_BASE_URL = "https://mediapi.onlinepharmaque.in/api/v1";

const SubCategoryModal = ({
  isOpen,
  subtoggleModal,
  selectedOption,
  setSelectedOption,
  subcategoryName,
  setSubcategoryName,
  isEditMode,
  editItemId,
  subCategories = [],
  onReloadData,
}) => {
  const [categories, setCategories] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState("");

  const [categoryError, setCategoryError] = useState("");
  const [subcategoryError, setSubcategoryError] = useState("");

  // ✅ Load categories
  useEffect(() => {
    fetch(`${GET_CAT_API_BASE_URL}/getallcategory`)
      .then((res) => res.json())
      .then((data) => setCategories(data.category || []))
      .catch(() => toast.error("Category load failed"));
  }, []);

  // ✅ Set category ID in edit mode
  useEffect(() => {
    if (isEditMode && selectedOption && categories.length > 0) {
      const cat = categories.find(
        (c) => c.MaincategoryName === selectedOption
      );
      setSelectedCategoryId(cat?._id || "");
    }
  }, [isEditMode, selectedOption, categories]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setCategoryError("");
    setSubcategoryError("");

    let isValid = true;

    if (!selectedOption) {
      setCategoryError("Please select a category");
      isValid = false;
    }

    if (!subcategoryName) {
      setSubcategoryError("Please enter sub category name");
      isValid = false;
    }

    // ✅ duplicate check
    const isDuplicate = subCategories.some(
      (sub) =>
        sub.mainCategoryName === selectedOption &&
        sub.SubCateoryName === subcategoryName &&
        sub._id !== editItemId
    );

    if (isDuplicate) {
      setSubcategoryError("Subcategory already exists");
      isValid = false;
    }

    if (!isValid) return;

    try {
      const url = isEditMode
        ? `${GET_CAT_API_BASE_URL}/updatesubcategiry/${editItemId}`
        : `${GET_CAT_API_BASE_URL}/addSubcategory/${selectedCategoryId}`;

      // ✅ SEND JSON (IMPORTANT FIX)
      const bodyData = {
        SubCateoryName: subcategoryName,
        mainCategoryName: selectedOption,
      };

      const response = await fetch(url, {
        method: isEditMode ? "PATCH" : "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) throw new Error("Failed");

      const data = await response.json();
      toast.success(data.message || "Success");

      onReloadData();
      setSelectedOption("");
      setSubcategoryName("");
      subtoggleModal();
    } catch (error) {
      toast.error("Something went wrong");
      console.error(error);
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 bg-black/70 z-40" onClick={subtoggleModal} />

      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="w-[480px] bg-[#1F2A40] rounded-xl shadow-xl">

          <div className="flex justify-between px-6 py-4 border-b border-gray-700">
            <h2 className="text-white text-lg font-semibold">
              {isEditMode ? "Edit Sub Category" : "Add Sub Category"}
            </h2>
            <button onClick={subtoggleModal} className="text-white">✕</button>
          </div>

          <form onSubmit={handleSubmit} className="p-6 space-y-4">

            {/* Category */}
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-[#1F2A40] px-1 text-xs text-gray-400">
                Select Category
              </label>

              <select
                value={selectedOption}
                onChange={(e) => {
                  setSelectedOption(e.target.value);

                  const cat = categories.find(
                    (c) => c.MaincategoryName === e.target.value
                  );

                  setSelectedCategoryId(cat?._id || "");
                }}
                className="w-full p-3 pt-4 rounded bg-[#141B2D] text-white border border-gray-600"
              >
                <option value="">Select Category</option>
                {categories.map((cat) => (
                  <option key={cat._id} value={cat.MaincategoryName}>
                    {cat.MaincategoryName}
                  </option>
                ))}
              </select>

              {categoryError && (
                <p className="text-red-500 text-xs mt-1">{categoryError}</p>
              )}
            </div>

            {/* Subcategory */}
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-[#1F2A40] px-1 text-xs text-gray-400">
                Subcategory Name
              </label>

              <input
                value={subcategoryName}
                onChange={(e) => setSubcategoryName(e.target.value)}
                className="w-full p-3 pt-4 rounded bg-[#141B2D] text-white border border-gray-600"
              />

              {subcategoryError && (
                <p className="text-red-500 text-xs mt-1">{subcategoryError}</p>
              )}
            </div>

            <div className="flex justify-end gap-3 pt-4">
              <button
                type="button"
                onClick={subtoggleModal}
                className="px-4 py-2 bg-red-500 text-white rounded"
              >
                Cancel
              </button>

              <button
                type="submit"
                className="px-4 py-2 bg-emerald-500 text-white rounded"
              >
                {isEditMode ? "Update" : "Save"}
              </button>
            </div>

          </form>
        </div>
      </div>
    </>
  );
};

export default SubCategoryModal;